import * as strs from './commonStrings'
import * as iid from './bookingElementId'
import Modal from './modal'
import { Stack, Box, Typography, Button, Paper, Link } from '@mui/material'
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material/'
import { successPopUpKeyDown } from './snippets'
import { useEffect, useRef, useState, useLayoutEffect } from 'react'
import { ewayBillDateFormat, float, focusElemnt, generateChecksum } from './helper'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'
import ImageIcon from '@mui/icons-material/Image'
import HideImageIcon from '@mui/icons-material/HideImage'
import { HANS_COMPANY_ID, RAJESH_TRANSPORT, STA_COMPANY_ID } from '../../helper/companyIdhardcode'
import { getOtherCharges, getReverseFreight } from './bookingHelper'
import { useAtom } from 'jotai'
import { companySettingsAtom, qrProcessignFees } from './jotaiState/commonStateAtoms'
import { bookingQrUrl, timerAtom } from './atoms'
import { alertAtom, modalAtom } from './jotaiState/globalStateAtoms'
import { useDispatch } from 'react-redux'
import { getDQRDetailsInsertUpdate } from '../../store/booking/booking_action'
import { updateAlertError } from '../../store/common/common_action'
import { GetRequest, PostRequest } from './api'
import QRTimer from '../header/QRTimer'
import { urls } from './constants'
import { getCurrentDateTime } from './dateHelpers'
import { useTranslation } from '../../i18n/I18nProvider'

export const BookingConfirm = (props) => {
  const { data, updateModal, loginData } = props
  const { translations } = useTranslation()
  const bt = translations?.booking || {}
  const ct = translations?.common || {}
  const bookingConfirmation = bt.bookingConfirmation || strs.bookingConfirm
  const startingCity = bt.startingCity || ct.startingCity || strs.sourceCity
  const startingBranch = bt.startingBranch || ct.startingBranch || strs.sourceBranch
  const senderMobileNo = bt.senderMobileNo || strs.senderNo
  const senderNameLabel = bt.senderName || strs.senderName
  const senderCityState = bt.senderCityState || 'Sender State & City'
  const destinationCityLabel = bt.destinationCity || ct.destinationCity || strs.destinationCity
  const destinationBranch = bt.destinationBranch || strs.destinationBranch
  const receiverNo = bt.receiverNo || strs.receiverNo
  const receiverNameLabel = bt.receiverName || strs.receiverName
  const receiverCityState = bt.receiverCityState || 'Receiver State & City'
  const paymentType = bt.paymentType || ct.paymentType || 'Payment Type'
  const serviceType = bt.serviceType || 'Service Type'
  const godownDelivery = bt.godownDelivery || 'Godown Delivery'
  const billNoLabel = bt.billNo || 'Party Bill No'
  const billDateLabel = bt.billDate || 'Party Bill Date'
  const billAmountLabel = bt.billAmount || 'Party Bill Amount'
  const closeInformation = bt.closeInformation || 'Close Information'
  const moreInformation = bt.moreInformation || 'More Information'
  const senderGSTN = bt.senderGSTN || strs.senderGstn
  const senderIDProof = bt.senderIDProof || 'Sender ID Proof'
  const senderSecondNo = bt.senderSecondNo || 'Sender Alt. Number'
  const senderEmailId = bt.senderEmailId || 'Sender Email ID'
  const pickupAddress = bt.pickupAddress || ct.pickup || 'Pickup Address'
  const pincode = bt.pincode || ct.pincode || 'Pincode'
  const receiverGSTN = bt.receiverGSTN || strs.receiverGstn
  const receiverIDProof = bt.receiverIDProof || 'Receiver ID Proof'
  const receiverSecondNo = bt.receiverSecondNo || 'Receiver Alt. Number'
  const receiverEmailId = bt.receiverEmailId || 'Receiver Email ID'
  const deliveryAddress = bt.deliveryAddress || ct.deliveryAddress || 'Delivery Address'
  const operatorGSTIN = bt.operatorGSTIN || 'Operator GSTIN'
  const serviceProvGSTIN = bt.serviceProvGSTIN || 'Service Prov. GSTIN'
  const serviceRcvrGSTIN = bt.serviceRcvrGSTIN || 'Service Rcvr. GSTIN'
  const eWayBillNo = bt.eWayBillNo || 'Eway Bill Number'
  const ewayBillDate = bt.ewayBillDate || 'Eway Bill Date'
  const ewayBillValidUpto = bt.ewayBillValidUpto || 'Eway Bill Valid Upto'
  const payWithUpiQr = bt.payWithUpiQr || 'Pay With UPI Qr'
  const generateQr = bt.generateQr || 'Generate QR'
  const freightCalculation = bt.freightCalculation || 'Freight Calculation'
  const consignmentType = bt.consignmentType || ct.consignmentType || strs.consignmentType
  const methodOfPacking = bt.methodOfPacking || ct.packMethod || 'Method of Packing'
  const description = bt.description || ct.description || strs.description
  const totalUnit = bt.totalUnit || 'Total Unit'
  const declaredValue = bt.declaredValue || ct.goodsValue || 'Declared Value'
  const actualWeight = bt.actualWeight || ct.weightActual || 'Actual Weight'
  const sizeCFT = bt.sizeCFT || ct.sizeCFT || 'Size (CFT)'
  const volumeWeight = bt.volumeWeight || ct.weightCFT || 'Volume Weight'
  const chargedWeight = bt.chargedWeight || ct.weightCharge || 'Charged Weight'
  const rate = bt.rate || ct.rate || strs.rate
  const freight = bt.freight || ct.freight || strs.freight
  const total = bt.total || ct.total || strs.total
  const otherCharges = bt.otherCharges || 'Other Charges'
  const crossing = bt.crossing || ct.crossing || 'Crossing'
  const pickupCartage = bt.pickupCartage || ct.pickupCartage || 'Pickup Cartage'
  const miscCartage = bt.miscCartage || ct.miscCartage || 'Mis. Cartage'
  const dropCartage = bt.dropCartage || ct.dropCartage || strs.delCartage
  const hamaliLabel = bt.hamali || ct.hamali || strs.hamali
  const opHamali = bt.opHamali || ct.opHamali || strs.opHamali
  const documentLabel = bt.document || 'Document'
  const insurance = bt.insurance || ct.insurance || strs.insurance
  const valuationLabel = bt.valuation || ct.valuation || strs.valuation
  const pickupLabel = bt.pickup || ct.pickup || 'Pickup'
  const dropoff = bt.dropoff || ct.dropoffFee || 'Dropoff'
  const convCharge = bt.convCharge || bt.convChrg || 'Conv. Charge'
  const bookingGST = bt.bookingGST || 'Booking GST'
  const totalChargesLabel = bt.totalCharges || strs.totalCharges
  const methodOfPayment = bt.methodOfPayment || 'Mode of Payment'
  const accountNo = bt.accountNo || 'Bank Account Number'
  const grossLRAmount = bt.grossLRAmount || 'Gross LR Amount'
  const totalFreightLabel = bt.totalFreight || ct.totalFreight || 'Total Freight'
  const remarks = bt.remarks || ct.remarks || 'Remarks'
  const cartageRemark = bt.cartageRemark || 'Cartage Remarks'
  const comment = bt.comment || 'Comments'
  const close = bt.close || ct.close || 'Close'
  const bookWithMpesaLabel = bt.bookWithMpesa || 'Book With M-Pesa'
  const unutilisedPaymentBooking = bt.unutilisedPaymentBooking || 'UnUtilised Payment Booking'
  const bookCargo = bt.bookCargo || 'Book Cargo'
  const { showQr = false, disabledQr = false } = props
  const dispatch = useDispatch()
  const { DefaultCurrencyID = 0 } = data
  const { consignmntData, priceSectionData } = data
  const { strtCity, strtBrnch, sendMobNo, sendName, senGstnNo, senCNnST, destCity, destBrnch, recMobNo } = data
  const { recName, recGstnNo, recCNnST, consignerCheck, consigneeCheck, selBookingType, slctdSndParty, slctdRcvrParty } = data
  const { billNo, billDate, billAmount, sendMobNo2, sendMailId, recMobNo2, recMailId, pickupAddressObj } = data
  const { ewayBillNoList, CCR, cmnt, deliveryAddressObj, ewayBillDetailsList, intCompanyID } = data
  const { senderIdType, senderIdNumber, senderIdImage } = data
  const [companySettings] = useAtom(companySettingsAtom)
  const { SetDefaultBookCargo = 0 } = companySettings
  const { RemoveQRTransFeeFromCustAmt = 0 } = companySettings
  const { RemoveCartageremark } = companySettings
  const { RemoveComment } = companySettings
  const { RemovePaymentMode } = companySettings
  const { RemoveAccountnumber } = companySettings
  const { RemoveSenderGSTINEwayBill, RemoveReceiverGSTIN } = companySettings
  const { RemoveSenderID = 0 } = companySettings
  const {
    RemovePickupcartage,
    RemoveMisccartage,
    RemoveBookingDropcartage,
    RemoveHamali,
    RemoveOpHamali,
    RemoveValuation,
    RemoveDocfee,
    RemovePickupfee,
    RemoveDropofffee,
    IsServiceTax,
  } = companySettings

  const IsRateIncludeAllCharge = slctdSndParty?.IsRateIncludeAllCharge ?? (slctdRcvrParty?.IsRateIncludeAllCharge || 0)
  const IsMultipleConsignment = consignmntData.length > 1
  const [QRData, setQRData] = useAtom(bookingQrUrl)
  const [, setModal] = useAtom(modalAtom)
  const [processingFees] = useAtom(qrProcessignFees)
  const [remainingTime, setRemainingTime] = useState(false)
  const [, setAlert] = useAtom(alertAtom)
  var totalUnits, totalDeclaredValue, totalWeight, totalWeightVolume, totalFreight, totalwt_actual
  if (IsMultipleConsignment) {
    totalUnits = consignmntData.reduce((n, { unit }) => n + parseInt(unit), 0)
    totalDeclaredValue = consignmntData.reduce((n, { goods_value }) => n + float(goods_value), 0)
    if (intCompanyID === STA_COMPANY_ID) {
      totalWeightVolume = consignmntData.reduce((n, { wt_volume, unit }) => n + float(wt_volume) * (unit || 1), 0)
    } else {
      totalWeightVolume = consignmntData.reduce((n, { wt_volume }) => n + float(wt_volume), 0)
    }
    totalwt_actual = consignmntData.reduce((n, { wt_actual }) => n + float(wt_actual), 0)
    totalWeight = consignmntData.reduce((n, { wt_charge }) => n + float(wt_charge), 0)
    totalFreight = consignmntData.reduce((n, { freight }) => n + float(freight), 0)
  } else {
    totalFreight = consignmntData?.[0]?.freight || 0
  }
  if (IsRateIncludeAllCharge) {
    totalFreight = totalFreight - getOtherCharges(priceSectionData)
  }
  const [customerOpen, setCustomerOpen] = useState(false)
  const [gstOpen, setGstOpen] = useState(false)
  const { del_cartage, hamali, op_hamali, valuation, doc_fee, dropoff_fee, pickup_fee, gst } = priceSectionData
  const { coll_cartage, CCBrkup_pckp, CCBrkup_cmsn } = priceSectionData
  const pickDropFee = float(pickup_fee) + float(dropoff_fee)
  let totalCharges = float(coll_cartage) + float(del_cartage) + float(hamali) + float(op_hamali)
  totalCharges += float(valuation) + float(doc_fee) + float(gst) + pickDropFee
  const totalPayble = float(totalFreight) + float(totalCharges)
  const ceildTotalPayble = Math.ceil(totalPayble / 5) * 5
  let ceilValue = 0
  if (intCompanyID === STA_COMPANY_ID) {
    ceilValue = ceildTotalPayble - totalPayble
  }
  const buttonRef1 = useRef(null)
  const buttonRef2 = useRef(null)
  useEffect(() => {
    //[5702, 6064, 664].includes(intCompanyID)
    if (SetDefaultBookCargo) {
      buttonRef1.current.focus()
    } else {
      buttonRef2.current.focus()
    }
  })
  useEffect(() => {
    if (DefaultCurrencyID === 2) setGstOpen(true)
  }, [DefaultCurrencyID])
  const [calcwidth, setWidth] = useState(0)
  const widthRef = useRef(null)

  useLayoutEffect(() => {
    setWidth(widthRef.current.offsetWidth)
  }, [widthRef])
  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
  const getvolumeWeight = (row) => {
    if (intCompanyID === STA_COMPANY_ID) {
      return `${row.wt_vlm_len || 0} X ${row.wt_vlm_wid || 0} X ${row.wt_vlm_ht || 0}`
    } else {
      return row.wt_volume
    }
  }
  let isCooldown = false
  const handleClick = () => {
    if (isCooldown) return
    isCooldown = true
    data?.yesAction && data.yesAction()
    setTimeout(() => {
      isCooldown = false
    }, 500000)
  }
  const bookWithMpesa = () => {
    data?.showMpesa && data?.showMpesa()
  }
  const bookWithUPI = () => {
    setModal('unUtilisedQrPayment')
  }
  const validatedBooking = () => {
    PostRequest(urls.getBookingValidation, data.bookingValidationObj).then((res) => {
      if (res.status === 'Success') {
        handleQrGenerate()
      } else {
        setAlert({ show: true, msg: res?.Message, nextId: '' })
      }
    })
  }
  const getURL = (amount, transferfee, rechargeId) => {
    let obj = {
      orderId: "_OrderID_",
      amount: amount,
      pgCharge: "0.00",
      pgAmount: amount,
      Status: 'PAYMENT_INITIATED',
      merchantTxnId: "_MTxnID_",
      pgTxnId: '',
      statusTime: getCurrentDateTime(),
      CompanyID: loginData?.intCompanyID,
      BranchID: loginData?.intBranchID,
      qrUTRNumber: '',
      RechargeStatus: '',
      transferfee: transferfee,
      PaymentProductTypeID: 1,
      BusinessVerticalID: 3,
      RechargeID: rechargeId,
      EventType: 'Cargo_Booking',
      MobileNo: consignerCheck ? slctdSndParty?.MobileNo : sendMobNo,
    }
    return urls.QRPaymentDetailsInsertV2 + Object.keys(obj).map(key => `${key}=${encodeURIComponent(obj[key])}`).join('&')
  }
  const handleQrGenerate = async () => {
    setRemainingTime(false)
    const totalAmount = float(totalFreight) + float(totalCharges) + float(ceilValue)
    const amtToBePaid = (processingFees * totalAmount) / 100
    const finalAmt = RemoveQRTransFeeFromCustAmt
      ? float(totalFreight) + float(totalCharges) + float(ceilValue)
      : amtToBePaid + (float(totalFreight) + float(totalCharges) + float(ceilValue))
    let body = {
      agentid: 0,
      agentuserid: 0,
      amount: finalAmt,
      application: 'crs',
      branchid: loginData?.intBranchID,
      branchuserid: loginData?.intUserID,
      companyid: loginData?.intCompanyID,
      deviceid: '',
      devicetype: 'web',
      paymentmethod: 'qr',
      tag1: 'crs_cargo_booking',
      tag2: '',
      transferfee: amtToBePaid,
      vertical: 'cargo',
      checksum: '',
    }
    const saltKey = 'salt-secret'
    const checksumValue = generateChecksum(body, saltKey)
    const payload = {
      ...body,
      checksum: checksumValue,
      extraInfo:{
            CrsCallback: getURL(finalAmt, amtToBePaid, 0)
        }
    }
    PostRequest('https://gpg.iamgds.com/api/v1/orders', payload).then(async (res) => {
      if (res?.isSuccess) {
        setQRData(res?.data?.qrUrl)
        handlePayment(res.data.orderId, 0)
      } else {
        setQRData('')
        setRemainingTime(false)
      }
    })
  }
  const handleStatus = (orderId, rechargeId) => {
    GetRequest(`https://gpg.iamgds.com/api/v1/orders/${orderId}/status`, {}).then((statusRes) => {
      if (statusRes?.isSuccess && rechargeId !== null && statusRes?.data?.status !== '') {
        let obj = {
          orderId: statusRes?.data?.orderId, //
          amount: statusRes?.data?.amount, //
          pgCharge: statusRes?.data?.pgCharge, //
          pgAmount: statusRes?.data?.pgAmount, //
          Status: statusRes?.data?.status, //confirm
          merchantTxnId: statusRes?.data?.merchantTxnId, //
          pgTxnId: statusRes?.data?.pgTxnId, //
          statusTime: statusRes?.data?.statusTime, //
          CompanyID: loginData?.intCompanyID,
          BranchID: loginData?.intBranchID,
          qrUTRNumber: statusRes?.data?.qrUTRNumber, //
          RechargeStatus: '', //confirm
          transferfee: statusRes?.data?.transferFee, //
          PaymentProductTypeID: 1,
          BusinessVerticalID: 3,
          RechargeID: rechargeId,
          EventType: 'Cargo_Booking',
          MobileNo: consignerCheck ? slctdSndParty?.MobileNo : sendMobNo,
        }
        dispatch(getDQRDetailsInsertUpdate(obj))
          .then((dispatchResult) => {
            if (dispatchResult?.status === 'Success') {
              if (statusRes.data.status === 'PAYMENT_SUCCESS') {
                setRemainingTime(false)
                clearInterval(intervalIdRef.current)
                data?.yesAction && data.yesAction({ QrOrderID: orderId, ModeOfPayment: 8 })
              } else if (statusRes.data.status === 'PAYMENT_FAILURE' || statusRes.data.status === 'PAYMENT_INITIATE_FAILED') {
                setRemainingTime(false)
                clearInterval(intervalIdRef.current)
                setAlert({ show: true, msg: bt.paymentFailed, nextId: '' })
              }
            } else {
              if (dispatchResult?.status === 'Fail') {
                dispatch(updateAlertError({ show: true, msg: dispatchResult?.ErrMessage, nextId: '' }))
                handleCloseIntervals()
              }
            }
          })
          .catch((err) => {
            dispatch(updateAlertError({ show: true, msg: err, nextId: '' }))
          })
      }
    })
  }
  const initialTimeoutRef = useRef(null)
  const endTimeoutRef = useRef(null)
  const intervalIdRef = useRef(null)
  const handleCloseIntervals = () => {
    clearInterval(intervalIdRef.current)
    clearTimeout(endTimeoutRef.current)
    clearTimeout(initialTimeoutRef.current)
    intervalIdRef.current = null
    endTimeoutRef.current = null
    initialTimeoutRef.current = null
  }
  const handlePayment = async (orderId, rechargeId = 0) => {
    setRemainingTime(true)
    await handleStatus(orderId, rechargeId)

    intervalIdRef.current = setInterval(async () => {
      await handleStatus(orderId, rechargeId)
    }, 10000)
    endTimeoutRef.current = setTimeout(
      () => {
        clearInterval(intervalIdRef.current)
        intervalIdRef.current = null
        dispatch(updateAlertError({ show: true, msg: bt.timeOutPleaseTryAgain, nextId: '' }))
        handleCloseIntervals()
        setRemainingTime(false)
      },
      15 * 60 * 1000
    )
  }

  return (
    <Modal
      headTxt={data.headTxt ? data.headTxt : bookingConfirmation}
      width={'90%'}
      updateModal={updateModal}
      closeId={iid.closeButton}
      modalClass={'booking-popup'}
      modalStyle={modalStyle}
    >
      <Box component="div" className="booking-confirmation-wrapper">
        <Box display="flex">
          <Box sx={{ width: '100%' }}>
            <Stack
              component={Paper}
              direction="row"
              spacing={2}
              sx={{ background: '#FFF', margin: '15px', boxShadow: 'none', alignItems: 'center' }}
              style={{ margin: 0 }}
              className="booking-confirmation-section"
            >
              <Box className="sender-receiver" sx={{ width: '100%', borderRadius: '10px' }}>
                <Box className="sr-row">
                  <Typography className="sr-label color-dark" sx={{ alignItems: 'left' }}>
                    {startingCity}
                  </Typography>
                  :
                  <Typography className="sr-value color-dark" sx={{ alignItems: 'left', width: calcwidth }}>
                    {strtCity?.CityName}
                  </Typography>
                </Box>
                <Box className="sr-row">
                  <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                    {startingBranch}
                  </Typography>
                  :
                  <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                    {strtBrnch?.BranchName}
                  </Typography>
                </Box>
                <Box className="sr-row">
                  <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                    {senderMobileNo}
                  </Typography>
                  :
                  <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                    {consignerCheck ? slctdSndParty?.MobileNo : sendMobNo}
                  </Typography>
                </Box>
                <Box style={{ display: customerOpen ? 'block' : 'none' }}>
                  <Box className="sr-row">
                    <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                      {senderNameLabel}
                    </Typography>
                    :
                    <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                      {consignerCheck ? slctdSndParty.Party : sendName}
                    </Typography>
                  </Box>
                  <Box className="sr-row">
                    <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                      {senderCityState}
                    </Typography>
                    :
                    <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                      {senCNnST}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box className="sender-receiver" sx={{ width: '100%', borderRadius: '10px' }}>
                <Box className="sr-row">
                  <Typography className="sr-label color-dark" sx={{ alignItems: 'left' }}>
                    {destinationCityLabel}
                  </Typography>
                  :
                  <Typography className="sr-value color-dark" sx={{ alignItems: 'left', width: calcwidth }}>
                    {destCity?.CityName}
                  </Typography>
                </Box>
                <Box className="sr-row">
                  <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                    {destinationBranch}
                  </Typography>
                  :
                  <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                    {destBrnch?.BranchName}
                  </Typography>
                </Box>
                <Box className="sr-row">
                  <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                    {receiverNo}
                  </Typography>
                  :
                  <Typography ref={widthRef} className="sr-value" sx={{ alignItems: 'left', width: '100%' }}>
                    {consigneeCheck ? slctdRcvrParty?.MobileNo : recMobNo}
                  </Typography>
                </Box>
                <Box style={{ display: customerOpen ? 'block' : 'none' }}>
                  <Box className="sr-row">
                    <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                      {receiverNameLabel}
                    </Typography>
                    :
                    <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                      {consigneeCheck ? slctdRcvrParty?.Party : recName}
                    </Typography>
                  </Box>
                  <Box className="sr-row">
                    <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                      {receiverCityState}
                    </Typography>
                    :
                    <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                      {recCNnST}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box className="sender-receiver" sx={{ width: '100%', borderRadius: '10px' }}>
                <Box className="sr-row">
                  <Typography className="sr-label color-dark" sx={{ alignItems: 'left' }}>
                    {paymentType}
                  </Typography>
                  :
                  <Typography className="sr-value color-dark" sx={{ alignItems: 'left', width: calcwidth }}>
                    {selBookingType.name}
                  </Typography>
                </Box>
                {intCompanyID !== RAJESH_TRANSPORT ? (
                  <Box className="sr-row">
                    <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                      {serviceType}
                    </Typography>
                    :
                    <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                      {godownDelivery}
                    </Typography>
                  </Box>
                ) : (
                  <></>
                )}
                <Box className="sr-row">
                  <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                    {billNoLabel}
                  </Typography>
                  :
                  <Typography className="sr-value" sx={{ alignItems: 'left', width: '100%' }}>
                    {billNo || 'NA'}
                  </Typography>
                </Box>
                <Box style={{ display: customerOpen ? 'block' : 'none' }}>
                  <Box className="sr-row">
                    <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                      {billDateLabel}
                    </Typography>
                    :
                    <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                      {(billDate && billDate.format('DD-MMM-YYYY')) || 'NA'}
                    </Typography>
                  </Box>
                  <Box className="sr-row">
                    <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                      {billAmountLabel}
                    </Typography>
                    :
                    <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                      {billAmount || 'NA'}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Stack>
            <Stack
              component={Paper}
              direction="row"
              spacing={2}
              sx={{ background: '#FFF', boxShadow: 'none', alignItems: 'center' }}
              className="booking-confirmation-section"
            >
              {customerOpen ? (
                <Box className="flex-center-all bcp-link" onClick={() => setCustomerOpen(false)}>
                  <RemoveCircleIcon id="iconBox1" className="icon active" style={{ fontSize: '14px', marginRight: '5px' }} />
                  <Link> {closeInformation}</Link>
                </Box>
              ) : (
                <Box className="flex-center-all bcp-link" onClick={() => setCustomerOpen(true)}>
                  <AddCircleIcon id="iconBox" className="icon active" style={{ fontSize: '14px', marginRight: '5px' }} />
                  <Link>{moreInformation}</Link>
                </Box>
              )}
            </Stack>
            <Stack
              component={Paper}
              direction="row"
              spacing={2}
              sx={{ background: '#FFF', boxShadow: 'none', alignItems: 'center' }}
              className="booking-confirmation-section"
            >
              <Box sx={{ width: '100%', height: '2px', background: '#ccc' }}></Box>
            </Stack>
            <Stack
              component={Paper}
              direction="row"
              spacing={2}
              sx={{ background: '#FFF', margin: '15px', boxShadow: 'none', alignItems: 'center' }}
              style={{ margin: 0 }}
              className="booking-confirmation-section"
            >
              <Box className="sender-receiver" sx={{ width: '100%', borderRadius: '10px' }}>
                {DefaultCurrencyID !== 2 ? (
                  <Box className="sr-row">
                    <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                      {senderGSTN}
                    </Typography>
                    :
                    <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                      {senGstnNo || 'NA'}
                    </Typography>
                  </Box>
                ) : (
                  ''
                )}
                <Box className="sr-row">
                  <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                    {senderIDProof}
                  </Typography>
                  :
                  <Typography className="sr-value flex" sx={{ alignItems: 'left', width: calcwidth }}>
                    {senderIdType?.IDProof ? senderIdType?.IDProof + ' | ' + senderIdNumber : ''}{' '}
                    {senderIdImage ? <ImageIcon sx={{ color: 'green' }} /> : <HideImageIcon sx={{ color: 'red' }} />}
                  </Typography>
                </Box>
                <Box style={{ display: gstOpen ? 'block' : 'none' }}>
                  {DefaultCurrencyID !== 2 ? (
                    <>
                      <Box className="sr-row">
                        <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                          {senderSecondNo}
                        </Typography>
                        :
                        <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                          {sendMobNo2 || 'NA'}
                        </Typography>
                      </Box>
                      <Box className="sr-row">
                        <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                          {senderEmailId}
                        </Typography>
                        :
                        <Typography className={`sr-value ${sendMailId ? 'lowercase' : ''}`} sx={{ alignItems: 'left', width: calcwidth }}>
                          {sendMailId || 'NA'}
                        </Typography>
                      </Box>
                    </>
                  ) : (
                    ''
                  )}
                  <Box className="sr-row">
                    <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                      {pickupAddress}
                    </Typography>
                    :
                    <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                      {pickupAddressObj?.formatted_address || 'NA'}
                    </Typography>
                  </Box>
                  <Box className="sr-row">
                    <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                      {pincode}
                    </Typography>
                    :
                    <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                      {pickupAddressObj?.pincode || 'NA'}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box className="sender-receiver" sx={{ width: '100%', borderRadius: '10px' }}>
                {DefaultCurrencyID !== 2 ? (
                  <Box className="sr-row">
                    <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                      {receiverGSTN}
                    </Typography>
                    :
                    <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                      {recGstnNo || 'NA'}
                    </Typography>
                  </Box>
                ) : (
                  ''
                )}
                <Box className="sr-row">
                  <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                    {receiverIDProof}
                  </Typography>
                  :
                  <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                    NA
                  </Typography>
                </Box>
                <Box style={{ display: gstOpen ? 'block' : 'none' }}>
                  {DefaultCurrencyID !== 2 ? (
                    <>
                      <Box className="sr-row">
                        <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                          {receiverSecondNo}
                        </Typography>
                        :
                        <Typography className="sr-value" sx={{ alignItems: 'left', width: '100%' }}>
                          {recMobNo2 || 'NA'}
                        </Typography>
                      </Box>
                      <Box className="sr-row">
                        <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                          {receiverEmailId}
                        </Typography>
                        :
                        <Typography className={`sr-value ${recMailId ? 'lowercase' : ''}`} sx={{ alignItems: 'left', width: calcwidth }}>
                          {recMailId || 'NA'}
                        </Typography>
                      </Box>
                    </>
                  ) : (
                    ''
                  )}
                  <Box className="sr-row">
                    <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                      {deliveryAddress}
                    </Typography>
                    :
                    <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                      {deliveryAddressObj?.formatted_address || 'NA'}
                    </Typography>
                  </Box>
                  <Box className="sr-row">
                    <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                      {pincode}
                    </Typography>
                    :
                    <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                      {deliveryAddressObj?.pincode || 'NA'}
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {DefaultCurrencyID !== 2 ? (
                <Box className="sender-receiver" sx={{ width: '100%', borderRadius: '10px' }}>
                  <Box className="sr-row">
                    <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                      {operatorGSTIN}
                    </Typography>
                    :
                    <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                      NA
                    </Typography>
                  </Box>
                  <Box className="sr-row">
                    <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                      {serviceProvGSTIN}
                    </Typography>
                    :
                    <Typography className="sr-value" sx={{ alignItems: 'left', width: '100%' }}>
                      {'NA'}
                    </Typography>
                  </Box>
                  <Box style={{ display: gstOpen ? 'block' : 'none' }}>
                    <Box className="sr-row">
                      <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                        {serviceRcvrGSTIN}
                      </Typography>
                      :
                      <Typography className="sr-value" sx={{ alignItems: 'left', width: '100%' }}>
                        {recGstnNo || 'NA'}
                      </Typography>
                    </Box>
                    <Box className="sr-row">
                      <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                        {eWayBillNo}
                      </Typography>
                      :
                      <Typography className="sr-value" sx={{ alignItems: 'left', width: '100%' }}>
                        {ewayBillNoList.join(',') || 'NA'}
                      </Typography>
                    </Box>
                    <Box className="sr-row">
                      <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                        {ewayBillDate}
                      </Typography>
                      :
                      <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                        {ewayBillDetailsList.length
                          ? ewayBillDetailsList.map(
                              (el, index, { length }) => ewayBillDateFormat(el.EwayBillDate) + (length - 1 === index ? '' : ', ')
                            )
                          : 'NA'}
                      </Typography>
                    </Box>
                    <Box className="sr-row">
                      <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                        {ewayBillValidUpto}
                      </Typography>
                      :
                      <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                        {ewayBillDetailsList.length
                          ? ewayBillDetailsList.map(
                              (el, index, { length }) => ewayBillDateFormat(el.ValidUpto) + (length - 1 === index ? '' : ', ')
                            )
                          : 'NA'}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              ) : (
                <Box className="sender-receiver" sx={{ width: '100%', borderRadius: '10px' }}></Box>
              )}
            </Stack>
            <Stack
              component={Paper}
              direction="row"
              spacing={2}
              sx={{ background: '#FFF', boxShadow: 'none', alignItems: 'center' }}
              className="booking-confirmation-section"
            >
              {gstOpen ? (
                <Box className="flex-center-all bcp-link" onClick={() => setGstOpen(false)}>
                  <RemoveCircleIcon id="iconBox1" className="icon active" style={{ fontSize: '14px', marginRight: '5px' }} />
                  <Link> {closeInformation}</Link>
                </Box>
              ) : (
                <Box className="flex-center-all bcp-link" onClick={() => setGstOpen(true)}>
                  <AddCircleIcon id="iconBox" className="icon active" style={{ fontSize: '14px', marginRight: '5px' }} />
                  <Link>{moreInformation}</Link>
                </Box>
              )}
            </Stack>
            <Stack
              component={Paper}
              direction="row"
              spacing={2}
              sx={{ background: '#FFF', boxShadow: 'none', alignItems: 'center' }}
              className="booking-confirmation-section"
            >
              <Box sx={{ width: '100%', height: '2px', background: '#ccc' }}></Box>
            </Stack>
          </Box>
          <Box sx={{ width: '300px', flexShrink: 0, textAlign: 'center' }} style={{ display: showQr ? 'block' : 'none' }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                flexDirection: 'column',
              }}
            >
              <Typography
                sx={{
                  fontWeight: 500,
                  textTransform: 'uppercase',
                  fontSize: '14px',
                  color: '#444',
                }}
                variant="h5"
              >
                {payWithUpiQr}
              </Typography>
              {QRData ? (
                <>
                  <div
                    id="qrCode"
                    className="QRimg"
                    style={{
                      display: 'flex', // Use flexbox
                      justifyContent: 'center', // Center horizontally
                      alignItems: 'center', // Center vertically
                      backgroundImage: `url(${QRData})`,
                      padding: '8px',
                      height: '168px',
                      width: '168px',
                      backgroundSize: 'cover', // Ensures the image covers the div
                      backgroundPosition: 'center', // Centers the image
                      border: '1px solid #ccc', // Optional: Add a border for better visibility
                    }}
                  />

                  {remainingTime ? <QRTimer /> : ''}
                </>
              ) : (
                <Button className="btn btn-primary" onClick={validatedBooking} disabled={disabledQr}>
                  {generateQr}
                </Button>
              )}
            </div>
          </Box>
        </Box>
        <Stack
          component={Paper}
          direction="row"
          spacing={2}
          sx={{ background: '#FFF', boxShadow: 'none', alignItems: 'center' }}
          className="booking-confirmation-section"
        >
          <Box className="color-dark">{freightCalculation}</Box>
        </Stack>
        <Stack
          component={Paper}
          direction="row"
          spacing={2}
          sx={{ background: '#FFF', margin: '15px', boxShadow: 'none' }}
          className="booking-confirmation-section"
        >
          <TableContainer className="table-container" component={Paper}>
            <Table
              className="table-consignment"
              style={{ minWidth: 650 }}
              size="medium"
              sx={{ fontSize: '15px' }}
              aria-label="a dense table"
            >
              <TableHead className="table-consignment-head" style={{ position: `sticky`, top: `0`, background: `#e5f3fa` }}>
                <TableRow>
                  <TableCell width={'16%'}>{consignmentType}</TableCell>
                  <TableCell width={'16%'}>{methodOfPacking}</TableCell>
                  <TableCell width={'16%'}>{description}</TableCell>
                  <TableCell width={'8%'} align="right">
                    {totalUnit}
                  </TableCell>
                  <TableCell width={'9%'} align="right">
                    {declaredValue}
                  </TableCell>
                  <TableCell width={'9%'} align="right">
                    {actualWeight}
                  </TableCell>
                  <TableCell width={'9%'} align="right">
                    {intCompanyID === STA_COMPANY_ID ? sizeCFT : volumeWeight}
                  </TableCell>
                  <TableCell width={'10%'} align="right">
                    {chargedWeight}
                  </TableCell>
                  <TableCell width={'8%'} align="right">
                    {rate}
                  </TableCell>
                  <TableCell style={{ minWidth: '120px' }} align="right">
                    {freight}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="table-consignment-body">
                {consignmntData?.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{item.slctdCnsgnmntType?.SubType}</TableCell>
                    <TableCell>{item.slctdMethodOfPckgType?.MOPName}</TableCell>
                    <TableCell>{item.description}</TableCell>
                    <TableCell align="right">{item.unit}</TableCell>
                    <TableCell align="right">{item.goods_value}</TableCell>
                    <TableCell align="right">{item.wt_actual}</TableCell>
                    <TableCell align="right">{getvolumeWeight(item)}</TableCell>
                    <TableCell align="right">{item.wt_charge}</TableCell>
                    <TableCell align="right">{float(item.rate)}</TableCell>
                    <TableCell align="right">
                      {getReverseFreight(consignmntData, index, priceSectionData, IsRateIncludeAllCharge) || item.freight}
                    </TableCell>
                  </TableRow>
                ))}
                {IsMultipleConsignment && (
                  <TableRow>
                    <TableCell colSpan={3} align="right" className="color-dark">
                      {total}
                    </TableCell>
                    <TableCell align="right" className="color-dark">
                      {totalUnits}
                    </TableCell>
                    <TableCell align="right" className="color-dark">
                      {totalDeclaredValue}
                    </TableCell>
                    <TableCell align="right" className="color-dark">
                      {totalwt_actual}
                    </TableCell>
                    <TableCell align="right" className="color-dark">
                      {totalWeightVolume}
                    </TableCell>
                    <TableCell align="right" className="color-dark">
                      {totalWeight}
                    </TableCell>
                    <TableCell colSpan={2} align="right" className="colored-cell">
                      {totalFreight}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Stack>
        <Stack
          component={Paper}
          direction="row"
          spacing={2}
          sx={{ background: '#FFF', boxShadow: 'none', alignItems: 'center' }}
          className="booking-confirmation-section"
        >
          <Box className="color-dark">{otherCharges}</Box>
        </Stack>
        <Stack
          component={Paper}
          direction="row"
          spacing={2}
          sx={{ background: '#FFF', margin: '15px', boxShadow: 'none' }}
          className="booking-confirmation-section"
        >
          <TableContainer className="table-container" component={Paper}>
            <Table
              className="table-consignment"
              style={{ minWidth: 650 }}
              size="medium"
              sx={{ fontSize: '15px' }}
              aria-label="a dense table"
            >
              <TableHead className="table-consignment-head" style={{ position: `sticky`, top: `0`, background: `#e5f3fa` }}>
                <TableRow>
                  {RemovePickupcartage ? (
                    <></>
                  ) : (
                    <TableCell width={`${9}%`} align="right">
                      {[HANS_COMPANY_ID].includes(loginData?.intCompanyID) ? crossing : pickupCartage}
                    </TableCell>
                  )}
                  {RemoveMisccartage ? (
                    <></>
                  ) : (
                    <TableCell width={`${10}%`} align="right">
                      {miscCartage}{' '}
                    </TableCell>
                  )}
                  {/* <TableCell width={`${9}%`} align="right">
                    Drop Cartage{' '}
                  </TableCell> */}
                  {RemoveBookingDropcartage ? (
                    <></>
                  ) : (
                    <TableCell width={`${10}%`} align="right">
                      {dropCartage}
                    </TableCell>
                  )}
                  {RemoveHamali ? (
                    <></>
                  ) : (
                    <TableCell width={`${5}%`} align="right">
                      {hamaliLabel}
                    </TableCell>
                  )}
                  {RemoveOpHamali ? (
                    <></>
                  ) : (
                    <TableCell width={`${7}%`} align="right">
                      {opHamali}
                    </TableCell>
                  )}
                  {RemoveDocfee ? (
                    <></>
                  ) : (
                    <TableCell width={`${7}%`} align="right">
                      {documentLabel}
                    </TableCell>
                  )}
                  {RemoveValuation ? (
                    <></>
                  ) : (
                    <TableCell width={`${7}%`} align="right">
                      {DefaultCurrencyID === 2 ? insurance : valuationLabel}
                    </TableCell>
                  )}
                  {RemovePickupfee ? (
                    <></>
                  ) : (
                    <TableCell width={`${6}%`} align="right">
                      {pickupLabel}
                    </TableCell>
                  )}
                  {RemoveDropofffee ? (
                    <></>
                  ) : (
                    <TableCell width={`${6}%`} align="right">
                      {dropoff}
                    </TableCell>
                  )}
                  {intCompanyID === STA_COMPANY_ID ? (
                    ''
                  ) : (
                    <TableCell width={`${9}%`} align="right">
                      {convCharge}
                    </TableCell>
                  )}
                  {DefaultCurrencyID !== 2 && IsServiceTax ? (
                    <TableCell width={`${7}%`} align="right">
                      {bookingGST}
                    </TableCell>
                  ) : (
                    ''
                  )}
                  <TableCell width={`${9}%`} align="right">
                    {totalChargesLabel}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="table-consignment-body">
                <TableRow>
                  {RemovePickupcartage ? <></> : <TableCell align="right">{float(CCBrkup_pckp)}</TableCell>}
                  {RemoveMisccartage ? <></> : <TableCell align="right">{float(CCBrkup_cmsn) + float(ceilValue)}</TableCell>}
                  {/* <TableCell align="right">{float(CCBrkup_rtrn)}</TableCell> */}
                  {RemoveBookingDropcartage ? <></> : <TableCell align="right">{float(del_cartage)}</TableCell>}
                  {RemoveHamali ? <></> : <TableCell align="right">{float(hamali)}</TableCell>}
                  {RemoveOpHamali ? <></> : <TableCell align="right">{float(op_hamali)}</TableCell>}
                  {RemoveDocfee ? <></> : <TableCell align="right">{float(doc_fee)}</TableCell>}
                  {RemoveValuation ? <></> : <TableCell align="right">{float(valuation)}</TableCell>}
                  {RemovePickupfee ? <></> : <TableCell align="right">{float(pickup_fee)}</TableCell>}
                  {RemoveDropofffee ? <></> : <TableCell align="right">{float(dropoff_fee)}</TableCell>}
                  {intCompanyID === STA_COMPANY_ID ? '' : <TableCell align="right">{0}</TableCell>}
                  {DefaultCurrencyID !== 2 && IsServiceTax ? <TableCell align="right">{float(gst)}</TableCell> : ''}
                  <TableCell align="right">{float(totalCharges) + float(ceilValue)}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Stack>
        <Stack
          component={Paper}
          direction="row"
          spacing={2}
          sx={{ background: '#FFF', boxShadow: 'none', alignItems: 'center' }}
          className="booking-confirmation-section summary-item"
        >
          <Box sx={{ width: '40%' }}>
            <Stack
              component={Paper}
              direction="row"
              spacing={2}
              sx={{ background: '#FFF', boxShadow: 'none', alignItems: 'center' }}
              className="booking-confirmation-section"
            >
              <Box className="color-dark">{methodOfPayment}</Box>
            </Stack>
            <TableContainer className="table-container" component={Paper}>
              <Table className="table-consignment" size="medium" sx={{ fontSize: '15px' }} aria-label="a dense table">
                <TableHead className="table-consignment-head" style={{ position: `sticky`, top: `0`, background: `#e5f3fa` }}>
                  <TableRow>
                    {RemovePaymentMode ? (
                      <></>
                    ) : (
                      <TableCell width={`${50}%`} className="colored-cell large-font">
                        {methodOfPayment}
                      </TableCell>
                    )}
                    {RemoveAccountnumber ? (
                      <></>
                    ) : (
                      <TableCell width={`${50}%`} className="colored-cell large-font">
                        {accountNo}
                      </TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody className="table-consignment-body">
                  <TableRow>
                    {RemovePaymentMode ? (
                      <></>
                    ) : (
                      <TableCell className="colored-cell large-font">{data?.selectedMethod?.ModeName}</TableCell>
                    )}
                    {RemoveAccountnumber ? (
                      <></>
                    ) : (
                      <TableCell className="colored-cell large-font">{data?.accountNo?.AccountNo || 'N/A'}</TableCell>
                    )}
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <Box sx={{ width: '60%' }} style={{ marginLeft: '10px' }}>
            <Stack
              component={Paper}
              direction="row"
              spacing={2}
              sx={{ background: '#FFF', boxShadow: 'none', alignItems: 'center' }}
              className="booking-confirmation-section"
            >
              <Box className="color-dark">{grossLRAmount}</Box>
            </Stack>
            <TableContainer className="table-container" component={Paper}>
              <Table className="table-consignment" size="medium" sx={{ fontSize: '15px' }} aria-label="a dense table">
                <TableHead className="table-consignment-head" style={{ position: `sticky`, top: `0`, background: `#e5f3fa` }}>
                  <TableRow>
                    <TableCell width={`${100 / 3}%`} align="right">
                      {totalFreightLabel}
                    </TableCell>
                    <TableCell width={`${100 / 3}%`} align="right">
                      {otherCharges}
                    </TableCell>
                    <TableCell width={`${100 / 3}%`} align="right" className="colored-cell large-font">
                      {grossLRAmount}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="table-consignment-body">
                  <TableRow>
                    <TableCell align="right">{float(totalFreight)}</TableCell>
                    <TableCell align="right">{float(totalCharges) + float(ceilValue)}</TableCell>
                    <TableCell align="right" className="colored-cell large-font">
                      {float(totalFreight) + float(totalCharges) + float(ceilValue)}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Stack>
        <Stack
          component={Paper}
          direction="row"
          spacing={2}
          style={{ margin: '0 0 10px' }}
          sx={{ background: '#FFF', boxShadow: 'none', alignItems: 'center', margin: 0, justifyContent: 'space-between' }}
          className="booking-confirmation-section"
        >
          <Box>
            <p className="bold">{remarks}</p>
            <p>NA</p>
          </Box>
          {CCR && !RemoveCartageremark ? (
            <Box>
              <p className="bold">{cartageRemark}</p>
              <p>{cmnt}</p>
            </Box>
          ) : (
            ''
          )}
          {cmnt && !RemoveComment ? (
            <Box>
              <p className="bold">{comment} </p>
              <p>{cmnt}</p>
            </Box>
          ) : (
            ''
          )}
        </Stack>
      </Box>
      <Box sx={{ width: '100%', height: '2px', background: '#ccc' }}></Box>
      <Box component="div" className="modal-btn-grp confirm-poup-grp" style={{ display: data?.hideContols ? 'none' : 'flex' }}>
        <Button
          ref={buttonRef2}
          className="btn cancel-btn margin-normal"
          variant="outlined"
          onClick={() => {
            setQRData('')
            data?.noAction()
            setTimeout(() => {
              focusElemnt('bookCargoButton')
            }, 3)
          }}
          onKeyDown={(e) => successPopUpKeyDown(e, buttonRef1)}
        >
          {close}
        </Button>
        {DefaultCurrencyID === 2 && selBookingType.typeId === 1 ? (
          <Button className="btn btn-primary margin-normal" onClick={bookWithMpesa} onKeyDown={(e) => successPopUpKeyDown(e, buttonRef1)}>
            {bookWithMpesaLabel}
          </Button>
        ) : (
          ''
        )}
        {DefaultCurrencyID !== 2 && showQr ? (
          <Button
            className="btn btn-primary margin-normal"
            onClick={bookWithUPI}
            onKeyDown={(e) => successPopUpKeyDown(e, buttonRef1)}
            disabled={disabledQr}
          >
            {unutilisedPaymentBooking}
          </Button>
        ) : (
          ''
        )}
        <Button
          ref={buttonRef1}
          className="btn btn-primary margin-normal"
          onClick={handleClick}
          disabled={!!QRData}
          onKeyDown={(e) => successPopUpKeyDown(e, buttonRef2)}
        >
          {bookCargo}
        </Button>
      </Box>
    </Modal>
  )
}
